"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUtils = exports.DEFAULT_BREAKPOINTS = void 0;
var styled_components_1 = require("styled-components");
var type_guard_1 = require("@webnuts/type-guard");
var css_types_1 = require("./css-types");
var transition_1 = require("./css-types/transition");
// https://getbootstrap.com/docs/4.5/layout/grid/#grid-options
exports.DEFAULT_BREAKPOINTS = {
    xlarge: 1200,
    large: 992,
    medium: 768,
    small: 576
};
var isBreakpointKey = function (value) {
    return type_guard_1.is(type_guard_1.enums(Object.keys(exports.DEFAULT_BREAKPOINTS)), value);
};
var createUtils = function (breakpoints) {
    if (breakpoints === void 0) { breakpoints = exports.DEFAULT_BREAKPOINTS; }
    var utils = {
        media: {
            between: function (options, styles) {
                var _a = __assign({ mediaType: 'all', unit: 'px' }, options), min = _a.min, max = _a.max, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                var minBreakpoint = typeof min === 'number' ? min : breakpoints[min];
                // https://github.com/twbs/bootstrap/blob/7058f8928641c847b6afb3a8ef2022ce75a5ded8/scss/mixins/_breakpoints.scss#L34-L39
                var maxBreakpoint = (typeof max === 'number' ? max : breakpoints[max]) - (unit === 'px' ? 0.02 : 0);
                var rules = __spread([
                    mediaType,
                    "(min-width: " + minBreakpoint + unit + ")",
                    "(max-width: " + maxBreakpoint + unit + ")"
                ], (orientation === undefined ? [] : ["(orientation: " + orientation + ")"]));
                var query = rules.join(' and ');
                return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          @media ", " {\n            ", "\n          }\n        "], ["\n          @media ", " {\n            ", "\n          }\n        "])), query, styles);
            },
            max: function (options, styles) {
                var normalizedOptions = typeof options === 'string' || typeof options === 'number' ? { target: options } : options;
                var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                // https://github.com/twbs/bootstrap/blob/7058f8928641c847b6afb3a8ef2022ce75a5ded8/scss/mixins/_breakpoints.scss#L34-L39
                var breakpoint = (typeof target === 'number' ? target : breakpoints[target]) - (unit === 'px' ? 0.02 : 0);
                var rules = __spread([
                    mediaType,
                    "(max-width: " + breakpoint + unit + ")"
                ], (orientation === undefined ? [] : ["(orientation: " + orientation + ")"]));
                var query = rules.join(' and ');
                return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          @media ", " {\n            ", "\n          }\n        "], ["\n          @media ", " {\n            ", "\n          }\n        "])), query, styles);
            },
            min: function (options, styles) {
                var normalizedOptions = typeof options === 'string' || typeof options === 'number' ? { target: options } : options;
                var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                var breakpoint = typeof target === 'number' ? target : breakpoints[target];
                var rules = __spread([
                    mediaType,
                    "(min-width: " + breakpoint + unit + ")"
                ], (orientation === undefined ? [] : ["(orientation: " + orientation + ")"]));
                var query = rules.join(' and ');
                return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          @media ", " {\n            ", "\n          }\n        "], ["\n          @media ", " {\n            ", "\n          }\n        "])), query, styles);
            },
            only: function (options, styles) {
                var normalizedOptions = typeof options === 'string'
                    ? isBreakpointKey(options)
                        ? { target: options }
                        : { mediaType: options }
                    : options;
                var _a = __assign({ mediaType: 'all', unit: 'px' }, normalizedOptions), target = _a.target, orientation = _a.orientation, mediaType = _a.mediaType, unit = _a.unit;
                if (target === undefined) {
                    var rules = __spread([mediaType], (orientation === undefined ? [] : ["(orientation: " + orientation + ")"]));
                    var query = rules.join(' and ');
                    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            @media ", " {\n              ", "\n            }\n          "], ["\n            @media ", " {\n              ", "\n            }\n          "])), query, styles);
                }
                var max = breakpoints[target];
                var min = Object.values(breakpoints).reduce(function (previous, current) {
                    return current < max && previous < current ? current : previous;
                }, 0);
                if (min === 0) {
                    return utils.media.max({ target: max, orientation: orientation, mediaType: mediaType, unit: unit }, styles);
                }
                else {
                    return utils.media.between({ min: min, max: max, orientation: orientation, mediaType: mediaType, unit: unit }, styles);
                }
            }
        },
        css: {
            rule: function (property, value) {
                var _a;
                return value === undefined ? '' : styled_components_1.css((_a = {}, _a[property] = value, _a));
            },
            font: type_guard_1.fakeAssertFunction([type_guard_1.optional(css_types_1.font)], function (font) {
                if (font === undefined) {
                    return '';
                }
                return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          ", ";\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n        "], ["\n          ", ";\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n        "])), utils.css.rule('font-size', font.size), utils.css.rule('font-family', font.family), utils.css.rule('font-style', font.style), utils.css.rule('font-weight', font.weight), utils.css.rule('letter-spacing', font.letterSpacing), utils.css.rule('line-height', font.lineHeight), utils.css.rule('text-transform', font.transform), utils.css.rule('text-align', font.align), utils.css.rule('text-decoration', font.decoration));
            }),
            border: type_guard_1.fakeAssertFunction([type_guard_1.optional(css_types_1.border)], function (border) {
                if (border === undefined) {
                    return '';
                }
                var width = border.width, styleOption = border.style, radiusOption = border.radius;
                var _a = typeof styleOption === 'string'
                    ? { top: styleOption, left: styleOption, bottom: styleOption, right: styleOption }
                    : __assign({}, styleOption), top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                var _b = typeof radiusOption === 'string'
                    ? { topRight: radiusOption, topLeft: radiusOption, bottomRight: radiusOption, bottomLeft: radiusOption }
                    : __assign({}, radiusOption), topRight = _b.topRight, topLeft = _b.topLeft, bottomRight = _b.bottomRight, bottomLeft = _b.bottomLeft;
                return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          border-style: solid;\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n        "], ["\n          border-style: solid;\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n        "])), utils.css.rule('border-width', width), utils.css.rule('border-top-style', top), utils.css.rule('border-left-style', left), utils.css.rule('border-bottom-style', bottom), utils.css.rule('border-right-style', right), utils.css.rule('border-top-right-radius', topRight), utils.css.rule('border-top-left-radius', topLeft), utils.css.rule('border-bottom-right-radius', bottomRight), utils.css.rule('border-bottom-left-radius', bottomLeft));
            }),
            padding: type_guard_1.fakeAssertFunction([type_guard_1.optional(css_types_1.padding)], function (padding) {
                return padding === undefined
                    ? ''
                    : styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n              ", "\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n              ", "\n            "])), utils.css.rule('padding-top', padding.top), utils.css.rule('padding-left', padding.left), utils.css.rule('padding-bottom', padding.bottom), utils.css.rule('padding-right', padding.right));
            }),
            transition: type_guard_1.fakeAssertFunction([type_guard_1.optional(transition_1.transitions(['']))], function (transitions) {
                return transitions === undefined
                    ? ''
                    : styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n              transition: ", ";\n            "], ["\n              transition: ",
                        ";\n            "])), Object.entries(transitions)
                        .map(function (_a) {
                        var _b = __read(_a, 2), rule = _b[0], _c = _b[1], duration = _c.duration, func = _c.function, delay = _c.delay;
                        return rule + " " + duration + " " + (func !== null && func !== void 0 ? func : '') + " " + (delay !== null && delay !== void 0 ? delay : '');
                    })
                        .join(', '));
            }),
            shadow: type_guard_1.fakeAssertFunction([type_guard_1.optional(css_types_1.shadow)], function (shadow) {
                if (shadow === undefined) {
                    return '';
                }
                var inset = shadow.inset, x = shadow.x, y = shadow.y, blur = shadow.blur, spread = shadow.spread, color = shadow.color;
                return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          box-shadow: ", " ", " ", " ", " ", " ", ";\n        "], ["\n          box-shadow: ", " ", " ", " ", " ", " ", ";\n        "])), inset === true ? 'inset' : '', x, y, blur, spread, color);
            }),
            outline: type_guard_1.fakeAssertFunction([type_guard_1.optional(css_types_1.outline)], function (outline) {
                throw new Error('Not Implemented - remove it???');
            })
        }
    };
    return utils;
};
exports.createUtils = createUtils;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
